import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthService } from "../app/shared/auth-service";
import { AdminGuard } from "../app/shared/admin-guard";

const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },

  // Kiosk mode - NO AUTHENTICATION REQUIRED
  {
    path: "survey-kiosk",
    loadChildren: () =>
      import("./pages/survey-kiosk/survey-kiosk.module").then(
        (m) => m.SurveyKioskModule
      ),
  },

  // Kiosk Token Admin - del av ADMIN (Administrator + eksplisitt modultilgang)
  {
    path: "kiosk-token-admin",
    loadChildren: () =>
      import("./pages/kiosk-token-admin/kiosk-token-admin.module").then(
        (m) => m.KioskTokenAdminModule
      ),
    canActivate: [AuthService, AdminGuard],
  },

  {
    path: "home",
    loadChildren: () =>
      import("./pages/home/home.module").then((m) => m.HomeModule),
    canActivate: [AuthService],
  },
  {
    path: "beholdning",
    loadChildren: () =>
      import("./pages/beholdning/beholdning.module").then(
        (m) => m.BeholdningModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "egne-tanker-automater",
    loadChildren: () =>
      import("./pages/egne-tanker-automater/egne-tanker-automater.module").then(
        (m) => m.EgneTankerAutomaterModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "orders",
    loadChildren: () =>
      import("./pages/ordrer/ordrer.module").then((m) => m.OrdrerModule),
    canActivate: [AuthService],
  },
  {
    path: "orders-sales",
    loadChildren: () =>
      import("./pages/ordrer-sales/ordrer-sales.module").then(
        (m) => m.OrdrerSalesModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "order-details",
    loadChildren: () =>
      import("./pages/ordre-details/ordre-details.module").then(
        (m) => m.OrdreDetailsModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "order-details-sales",
    loadChildren: () =>
      import("./pages/ordre-details-sales/ordre-details-sales.module").then(
        (m) => m.OrdreDetailsSalesModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "new-order",
    loadChildren: () =>
      import("./pages/new-order/new-order.module").then(
        (m) => m.NewOrderModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "new-order-sales",
    loadChildren: () =>
      import("./pages/new-order-sales/new-order-sales.module").then(
        (m) => m.NewOrderSalesModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "egne-tanker-select",
    loadChildren: () =>
      import("./pages/egne-tanker-select/egne-tanker-select.module").then(
        (m) => m.EgneTankerSelectModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "order-assignment",
    loadChildren: () =>
      import("./pages/order-assignment/order-assignment.module").then(
        (m) => m.OrderAssignmentModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "order-planner",
    loadChildren: () =>
      import("./pages/order-planner/order-planner.module").then(
        (m) => m.OrderPlannerModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "settings",
    loadChildren: () =>
      import("./pages/settings/settings.module").then((m) => m.SettingsModule),
    canActivate: [AuthService],
  },
  {
    path: "admin-settings",
    loadChildren: () =>
      import("./pages/admin-settings/admin-settings.module").then(
        (m) => m.AdminSettingsModule
      ),
    canActivate: [AuthService, AdminGuard],
  },
  {
    path: "activity-registration",
    loadChildren: () =>
      import("./pages/activity-registration/activity-registration.module").then(
        (m) => m.ActivityRegistrationModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "transaction-log",
    loadChildren: () =>
      import("./pages/transaction-log/transaction-log.module").then(
        (m) => m.TransactionLogModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "activity-registration-multiple",
    loadChildren: () =>
      import(
        "./pages/activity-registration-multiple/activity-registration-multiple.module"
      ).then((m) => m.ActivityRegistrationMultipleModule),
    canActivate: [AuthService],
  },
  {
    path: "release-notes",
    loadChildren: () =>
      import("./pages/release-notes/release-notes.module").then(
        (m) => m.ReleaseNotesModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "tank-monitoring",
    loadChildren: () =>
      import("./pages/tank-monitoring/tank-monitoring.module").then(
        (m) => m.TankMonitoringModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "tank-monitoring2",
    loadChildren: () =>
      import("./pages/tank-monitoring2/tank-monitoring.module2").then(
        (m) => m.TankMonitoring2Module
      ),
    canActivate: [AuthService],
  },
  {
    path: "stock-goods",
    loadChildren: () =>
      import("./pages/stock-goods/stock-goods.module").then(
        (m) => m.StockGoodsModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "new-customer",
    loadChildren: () =>
      import("./pages/customer-create/customer-create.module").then(
        (m) => m.CustomerCreateModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "work-orders-documents",
    loadChildren: () =>
      import("./pages/work-orders-documents/work-orders-documents.module").then(
        (m) => m.WorkOrdersDocumentsModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "work-order-details",
    loadChildren: () =>
      import("./pages/work-order-details/work-order-details.module").then(
        (m) => m.WorkOrderDetailsModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "work-new-order",
    loadChildren: () =>
      import("./pages/work-new-order/work-new-order.module").then(
        (m) => m.WorkNewOrderModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "work-order-history",
    loadChildren: () =>
      import("./pages/work-order-history/work-order-history.module").then(
        (m) => m.WorkOrderHistoryModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "workorder-approval",
    loadChildren: () =>
      import("./pages/workorder-approval/workorder-approval.module").then(
        (m) => m.WorkorderApprovalPageModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "work-orders",
    loadChildren: () =>
      import("./pages/work-orders/work-orders.module").then(
        (m) => m.WorkOrdersPageModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "documentation",
    loadChildren: () =>
      import("./pages/documentation/documentation.module").then(
        (m) => m.DocumentationModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "new-deviation",
    loadChildren: () =>
      import("./pages/new-deviation/new-deviation.module").then(
        (m) => m.NewDeviationModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "customer-lead",
    loadChildren: () =>
      import("./pages/customer-lead/customer-lead.module").then(
        (m) => m.CustomerLeadModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "orders-product",
    loadChildren: () =>
      import("./pages/orders-product/orders-product.module").then(
        (m) => m.OrdrersProductModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "order-details-product",
    loadChildren: () =>
      import("./pages/ordre-details-product/ordre-details-product.module").then(
        (m) => m.OrdreDetailsProductModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "new-order-product",
    loadChildren: () =>
      import("./pages/new-order-product/new-order-product.module").then(
        (m) => m.NewOrderProductModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "documents",
    loadChildren: () =>
      import("./pages/documents/documents.module").then(
        (m) => m.DocumentsModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "fleet",
    loadChildren: () =>
      import("./pages/fleet/fleet.module").then((m) => m.FleetModule),
    canActivate: [AuthService],
  },
  {
    path: "lead-view",
    loadChildren: () =>
      import("./pages/lead-view/lead-view.module").then(
        (m) => m.LeadViewModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "checklist-view",
    loadChildren: () =>
      import("./pages/checklist-view/checklist-view.module").then(
        (m) => m.ChecklistViewModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "forms-handling",
    loadChildren: () =>
      import("./pages/forms-handling/forms-handling.module").then(
        (m) => m.FormsHandlingModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "checklist-monthly-control",
    loadChildren: () =>
      import(
        "./pages/checklist-monthly-control/checklist-monthly-control.module"
      ).then((m) => m.ChecklistMonthlyControlModule),
    canActivate: [AuthService],
  },
  {
    path: "tank-monitoring-select",
    loadChildren: () =>
      import(
        "./pages/tank-monitoring-select/tank-monitoring-select.module"
      ).then((m) => m.TankMonitoringSelectModule),
    canActivate: [AuthService],
  },
  {
    path: "dynamic-form",
    loadChildren: () =>
      import("./pages/dynamic-form/dynamic-form.module").then(
        (m) => m.DynamicFormModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "landax-form",
    loadChildren: () =>
      import("./pages/landax-form/landax-form.module").then(
        (m) => m.LandaxFormModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "landax-form/:formId",
    loadChildren: () =>
      import("./pages/landax-form/landax-form.module").then(
        (m) => m.LandaxFormModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "landax-upload/:id",
    loadChildren: () =>
      import("./pages/landax-upload/landax-upload.module").then(
        (m) => m.LandaxUploadPageModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "incident-type-selector",
    loadChildren: () =>
      import("./pages/incident-type-selector/incident-type-selector.module").then(
        (m) => m.IncidentTypeSelectorModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "my-forms",
    loadChildren: () =>
      import("./pages/my-forms/my-forms.module").then(
        (m) => m.MyFormsModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "my-incidents", // Keep for backwards compatibility, redirect to my-forms
    redirectTo: "my-forms",
    pathMatch: "full"
  },
  {
    path: "incident-detail/:id",
    loadChildren: () =>
      import("./pages/incident-detail/incident-detail.module").then(
        (m) => m.IncidentDetailPageModule
      ),
    canActivate: [AuthService],
  },
  // Survey/Checklist routes
  {
    path: "survey-definition-selector",
    loadChildren: () =>
      import("./pages/survey-definition-selector/survey-definition-selector.module").then(
        (m) => m.SurveyDefinitionSelectorModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "survey-form/:definitionId",
    loadChildren: () =>
      import("./pages/survey-form/survey-form.module").then(
        (m) => m.SurveyFormModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "my-surveys",
    loadChildren: () =>
      import("./pages/my-surveys/my-surveys.module").then(
        (m) => m.MySurveysModule
      ),
    canActivate: [AuthService],
  },
  {
    path: "survey-detail/:id",
    loadChildren: () =>
      import("./pages/survey-detail/survey-detail.module").then(
        (m) => m.SurveyDetailModule
      ),
    canActivate: [AuthService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
